import http from './http';

export interface Workspace {
  id: string;
  name: string;
  description?: string | null;
  creator_id: string;
  created_at?: string;
}

export interface WorkspaceCreate {
  name: string;
  description?: string;
}

export interface ModuleWorkspaceActivity {
  workspace: Workspace;
  activity_count: number;
}

export interface WorkspaceMember {
  membership_id: string | null;
  user_id: string;
  username: string;
  email: string;
  role: 'owner' | 'admin' | 'member';
  joined_at?: string | null;
  is_workspace_owner: boolean;
}

export interface WorkspaceMembersResponse {
  workspace_id: string;
  can_manage: boolean;
  members: WorkspaceMember[];
}

export const workspacesApi = {
  list: () => http.get<Workspace[]>('/workspaces'),

  get: (id: string) => http.get<Workspace>(`/workspaces/${id}`),

  create: (data: WorkspaceCreate) => http.post<Workspace>('/workspaces', data),

  update: (id: string, data: Partial<WorkspaceCreate>) =>
    http.put<Workspace>(`/workspaces/${id}`, data),

  delete: (id: string) => http.delete(`/workspaces/${id}`),

  members: {
    list: (workspaceId: string) =>
      http.get<WorkspaceMembersResponse>(`/workspaces/${workspaceId}/members`),

    add: (workspaceId: string, username: string, role: 'admin' | 'member') =>
      http.post<WorkspaceMember>(`/workspaces/${workspaceId}/members`, { username, role }),

    update: (workspaceId: string, userId: string, role: 'admin' | 'member') =>
      http.put<WorkspaceMember>(`/workspaces/${workspaceId}/members/${userId}`, { role }),

    remove: (workspaceId: string, userId: string) =>
      http.delete(`/workspaces/${workspaceId}/members/${userId}`),
  },

  moduleActivity: (module?: string, workspaceId?: string) =>
    http.get<ModuleWorkspaceActivity[]>('/workspaces/module-activity', {
      params: {
        ...(module ? { module } : {}),
        ...(workspaceId ? { workspace_id: workspaceId } : {}),
      },
    }),
};
